<template>
  <section class="dir-layout">
    <PlansSidebar :activeTab="activeTab" @change-tab="onChangeTab" />

    <div class="dir-content">
      <div class="dir-content-body">
        <!-- Mobile tabs -->
        <div class="dir-tabs d-lg-none">
          <button
            v-for="tab in tabs"
            :key="tab.key"
            class="dir-tab"
            :class="{ active: activeTab === tab.key }"
            @click="onChangeTab(tab.key)"
          >
            {{ tab.label }}
          </button>
        </div>

        <SignaturePendingBanner v-if="$route.name !== 'plans.additionals.signature'" />
        <router-view />
      </div>
    </div>
  </section>
</template>

<script>
import PlansSidebar from "../components/PlansSidebar";
import SignaturePendingBanner from "../components/SignaturePendingBanner";

const TAB_ROUTE_MAP = {
  plans: "plans",
  additionals: "plans.additionals",
  history: "plans.history"
};

export default {
  name: "PlansLayout",
  components: { PlansSidebar, SignaturePendingBanner },
  computed: {
    activeTab() {
      const name = this.$route.name;
      if (name === "plans") return "plans";
      if (
        name === "plans.additionals" ||
        name === "plans.additionals.checkout" ||
        name === "plans.additionals.signature"
      )
        return "additionals";
      if (name === "plans.history") return "history";
      return "plans";
    },
    tabs() {
      return [
        { key: "plans", label: "Planes" },
        { key: "additionals", label: "Adicionales" },
        { key: "history", label: "Historial" }
      ];
    }
  },
  methods: {
    onChangeTab(tab) {
      const routeName = TAB_ROUTE_MAP[tab];
      if (routeName && this.$route.name !== routeName) {
        this.$router.push({ name: routeName }).catch(() => {});
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
